<template>
  <div class="account-reset">
    <ResetForm v-if="showAccountType == 'reset'" @login="onLogin" @cancel="emits('cancel')" />
    <div v-if="!$isPure" class="footer">
      {{ $t('yu-dao-qi-ta-wen-ti-jin-hang-zhang-hao-shen-su-qing-zhi-jie') }}
      <a @click="openTalk">{{ $t('lian-xi-ke-fu') }}</a>
    </div>
  </div>
</template>

<script lang="ts" setup>
import ResetForm from './form.vue';

const showAccountType = useAccountType();
const emits = defineEmits(['cancel']);
const { $isPure } = useNuxtApp();

const onLogin = () => {
  showAccountType.value = 'login';
};

const openTalk = () => {
  openCustomerService();
};
</script>

<style lang="scss" scoped>
.account-reset {
  @apply h-full;
  .footer {
    @apply absolute bottom-0 w-full bg-secondary-6 mt-[40px] flex items-center text-[12px] justify-center text-font-1;
    height: 40px;
    border-radius: 0 0 6px 6px;
  }
}
</style>
